<template>
	<div>
		<h1>
			GAMES
		</h1>

		<p>{{ error }}</p>

		<div v-for="game in gamesList" :key="game._id" class="gameItem">
			{{ game.name }}
			<a :href="'https://' + game.slug + '.game.rpgroot.com'">PLAY</a>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Requester } from '../requester';

@Options({
  data() {
    return {
      gamesList: [] as any[],
      error: ''
    };
  },
  created() {
    this.getGamesList();
  },
  methods: {
    async getGamesList() {
      const result = await Requester.get<any>('agg/games-list');
      if ('data' in result) {
        // if (result.data) {
        this.gamesList = result.data as Array<any>;
      } else {
        console.error(result);
      }
    }
  }
})
export default class Games extends Vue {}
</script>

<style>

</style>
